/**
 * Class that defines a SYDLE ONE reference.
 * @author leonardo.couto
 */

export class Reference {
  /** _Id of the referenced object. */
  _id: string;

  /** _Id of the referenced class. */
  _classId: string;

  // /** Review. */
  // revision?: string;

  /** Card text (high relevance). */
  cardText?: string;

  /**
   * @param _id - ID of the referenced object.
   * @param _classId - ID of the class to which the referenced object belongs.
   */
  constructor(_id: string, _classId: string) {
    this._id = _id;
    this._classId = _classId;
  }

  /**
   * Checks if the reference is valid.
   * @param ref - Reference.
   * @returns Indicates whether the reference is valid.
   */
  static isValid(ref: Reference): boolean {
    if (!ref._id || !ref._classId) return false;
    return true;
  }
}

export class GetCardByReferenceArgs {
  /** _Id of the referenced object. */
  _id: string;

  /** _Id of the referenced class. */
  _classId: string;

  // /** Review. */
  // revision?: string;

  /** Card text (high relevance). */
  cardText?: string;

  /** Timeline */
  timeline?: boolean;

  /**
   * @param _id - ID of the referenced object.
   * @param _classId - ID of the class to which the referenced object belongs.
   */
  constructor(_id: string, _classId: string) {
    this._id = _id;
    this._classId = _classId;
  }

  /**
   * Checks if the reference is valid.
   * @param ref - Reference.
   * @returns Indicates whether the reference is valid.
   */
  static isValid(ref: Reference): boolean {
    if (!ref._id || !ref._classId) return false;
    return true;
  }
}
